// AiLocationDetails.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { canOpenLocationInGoogleMaps, openGoogleMaps } from 'utilities/googleMapsNavigation';

// CSS
import './AiLocationDetails.css';

// Icons
import Icon from 'svg/Icon';

const AiLocationDetails = React.memo(({ nodeTitle = '', entries = [] }) => {
  // ----- CONTEXT ----- //

  const { theme } = useTheme();
  const cleanTitle = String(nodeTitle || '').trim();
  const list = Array.isArray(entries) ? entries.filter(Boolean) : [];

  if (!cleanTitle && !list.length) return null;

  // ----- RENDER ----- //

  return (
    <div className="ai-location-details">

      {/* TITLE */}
      {cleanTitle ? (
        <div
          className="ai-location-details__title"
        >
          {cleanTitle}
        </div>
      ) : null}

      {list.map((entry, index) => {
        const fieldLabel = String(entry?.fieldLabel || 'Location').trim();
        const displayValue = String(entry?.displayValue || '').trim();
        const location = entry?.location && typeof entry.location === 'object'
          ? entry.location
          : null;
        const canOpenMaps = canOpenLocationInGoogleMaps(location);

        return (
          <div
            className="ai-location-details__row"
            key={`${fieldLabel}:${index}`}
          >

            {/* CONTENT */}
            <div className="ai-location-details__content">

              {/* LABEL */}
              <div
                className="ai-location-details__label"
              >
                {fieldLabel}
              </div>

              {/* VALUE */}
              {displayValue ? (
                <div
                  className="ai-location-details__value"
                >
                  {displayValue}
                </div>
              ) : null}
            </div>

            {/* MAPS BUTTON */}
            {canOpenMaps ? (
              <button
                className="ai-location-details__maps-button"
                type="button"
                title="Open in Google Maps"
                aria-label={`Open ${fieldLabel} in Google Maps`}
                onClick={() => openGoogleMaps(location)}
              >
                <Icon
                  iconKey="open_in_new"
                  color={theme.foregroundMuted}
                  size={18}
                />
              </button>
            ) : null}
          </div>
        );
      })}
    </div>
  );
});

// Dev Tools
AiLocationDetails.displayName = 'AiLocationDetails';

export default AiLocationDetails;
